import React, { useState, useEffect, useCallback } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import FuzzySearch from 'fuzzy-search'
import axios from 'axios'
import xml2js from 'xml2js'
import toast, { Toaster } from 'react-hot-toast'
import './Recording.css'
import TranscriptEditor from '../Studio/TranscriptEditor'
import cx from '../Utils/cx'
import { FlexContainerCentered, FlexWrap, VerticalLayout } from '../Components/'
import {
    Title,
    Para,
    Tag,
    Suspense,
    SearchBar,
    SearchButton,
    DropDown,
    Button,
} from '../Components/'
import { UserDropdown } from '../Components/AuthElements'
import Transcript from './Transcript'
import AVFile from './AVFile'
import tagTrimmer from '../tagTrimmer'
import { emotions } from '../Utils/getEmotion'
import { TextGrid } from 'textgrid'
import Timeline from './Timeline'
import { first } from 'lodash'
import { parse } from 'query-string'
import { SettingsSystemDaydreamOutlined } from '@material-ui/icons'

var parseSRT = require('parse-srt')
// var textgrid = require('textgrid');

export const THIS_REC = 'This recording'
export const ALL_REC = 'All recordings'

var isDefaultTranscript = true;
var published = false;
const actions = [];

// let nerWords = {
//     "name":["michelle"],
//     "country":["texas","usa"],
//     "commodity":["oil"]
// };

const Recording = ({ data, query: _query, id, transcriptId }) => {
    const recording = data.data
    const [state, setState] = useState(null)

    const EDIT_PAGES = {
        EDIT_VIDEO: 'Edit Video',
        EDIT_TRANSCRIPT: 'Edit Transcript',
        PUBLISH: 'Publish',
    }

    let defaultTranscript = recording._transcripts.find(
        (f) => f._id === recording._defaultTranscript
    )
    if (!defaultTranscript && recording._transcripts.length) {
        defaultTranscript = recording._transcripts[0]
    }
    if (transcriptId) {
        defaultTranscript = recording._transcripts.find(
            (f) => f._id === transcriptId
        )
    }

    useEffect(() => {
        document.title = recording.title + ' - Magor'
    }, [recording])
    const tags = tagTrimmer(recording.tags.map((tag) => tag.tagName))
    const [seek, setSeek] = useState(0)
    const [jump, jumpTo] = useState(null)
    const [query, setQuery] = useState(_query)
    const [highlights, setHighlights] = useState([])
    const [currentPage, setCurrentPage] = useState(
        transcriptId ? EDIT_PAGES.EDIT_TRANSCRIPT : 'Edit'
    )
    const [currentCaption, setCurrentCaption] = useState(null)
    const [imageAndSoundCaptions, setImageAndSoundCaptions] = useState([])
    const [speakers, setSpeakers] = useState([])
    const [topWords, setTopWords] = useState([])

    const [transcriptData, setTranscriptData] = useState(null)
    const [fileName, setFileName] = useState(null)
    const [defaultTranscriptPath, setDefaultTranscriptPath] = useState(null)


    const [transcriptHistory, setTranscriptHistory] = useState([])


    const __getFullContentOfSpeechSegment = (_words) => {
        var w = '';
        _words.map(_ => w+= _._ + ' ');
        return w.trim();
    }

    const handleWordChange = (slIndex, ssIndex, sentence ,fileFormat) => {

        actions.push(JSON.stringify(transcriptData))
        const prev = {...transcriptData};
        try {
            if (fileFormat.substring(fileFormat.indexOf('.')+1) == "xml"){
                const ss = prev.AudioDoc.SegmentList[slIndex].SpeechSegment[ssIndex];
                prev.AudioDoc.SegmentList[slIndex].SpeechSegment[ssIndex].Word = [{
                    $ : {
                        stime : ss.$.stime,
                        dur : ss.$.dur,
                        score : '1.0',
                    },
                    _ : sentence
                }];
            }
            else if (fileFormat.substring(fileFormat.indexOf('.')+1) == "srt"){
                prev[ssIndex].text = sentence;
            }
            else{
                return;
            }
        } catch (error) {
            console.log('Error',error)
        }

        // isDefaultTranscript = false;
        setTranscriptData(prev)
    }

    useEffect(() => {
        if (defaultTranscript) {
            (async () => {
                const { tempResourceUrl,draftResourceUrl } = defaultTranscript
                const transcriptFileName = tempResourceUrl.split('/').pop()
                setFileName(transcriptFileName)
                const transcriptXMLPath = draftResourceUrl != '' ? `static/transcripts/draft/${transcriptFileName}` : `static/transcripts/${transcriptFileName}`;
                isDefaultTranscript = draftResourceUrl != '' ? false : true;
                const { data } = await axios.get(`${process.env.REACT_APP_STUDIO_URL}/${transcriptXMLPath}`.toString());

                // get file format
                if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "xml"){
                    let parser = new xml2js.Parser()
                    setDefaultTranscriptPath(transcriptXMLPath)
                    parser.parseString(data, function (err, result) {
                        setTranscriptData(result)
                        actions.push(JSON.stringify(result))
                    })                   
                }
                else if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "srt"){
                    // convert srt file to json
                    let srtArr = parseSRT(data);
                    setTranscriptData(srtArr);
                    setDefaultTranscriptPath(transcriptXMLPath);
                }
                else if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "TextGrid"){
                    let textGrid = TextGrid.textgridToJSON(data);
                    console.log(textGrid);
                    var mergeArr = [];
                    for (let i=0; i < textGrid.items.length; i++){
                        for (let j=0; j < textGrid.items[i].intervals.length; j++){
                            if (textGrid.items[i].intervals[j].text != '--EMPTY--'){
                                textGrid.items[i].intervals[j]["itemIndex"] = i;
                                textGrid.items[i].intervals[j]["intervalIndex"] = j;
                                mergeArr.push(textGrid.items[i].intervals[j]);
                            }
                        }
                    }
                    mergeArr.sort(function (a, b) {
                        return a.xmin - b.xmin || a.xmax - b.xmax;
                    });
                    console.log(mergeArr);
                    setTranscriptData(mergeArr);
                    setDefaultTranscriptPath(transcriptXMLPath);
                }
                else if (transcriptXMLPath.substring(transcriptXMLPath.indexOf('.')+1) == "stm"){
                    let dataSplit = data.split(/\r?\n/)
                    // convert to array of json
                    var dataArr = [];
                    for (let i=0; i < dataSplit.length; i++){
                        if (!dataSplit[i] == ""){
                            var dataDict = {};
                            var getVars = dataSplit[i].split(" ");
                            dataDict["fileName"] = getVars[0];
                            dataDict["a"] = getVars[1];
                            dataDict["speaker"] = getVars[2];
                            dataDict["start"] = getVars[3];
                            dataDict["end"] = getVars[4];
                            dataDict["gender"] = getVars[5];
                            dataDict["text"] = getVars.slice(6,getVars.length).join(' ')
                            dataArr.push(dataDict)
                        }
                    }
                    setTranscriptData(dataArr);
                    setDefaultTranscriptPath(transcriptXMLPath);
                }
                else{
                    console.log(data)
                }
            })()
            setTimeout(() => {
                setState('erer')
            }, 1000)
        }
    }, [defaultTranscript])

    const mediaType = 'video'

    // const mediaType = mime.lookup(recording.path).split('/')[0]
    const setHighlight = useCallback((s, d, w) => {
        setHighlights((highlights) => {
            const newHighlights = [...highlights]
            let found
            for (let highlight of newHighlights) {
                if (highlight.s === s && highlight.d === d) {
                    highlight.w.add(w)
                    found = true
                    break
                }
            }
            if (!found)
                newHighlights.push({
                    s,
                    d,
                    w: new Set([w]),
                })
            return newHighlights
        })
    }, [])

    const performSearch = (s) => {
        setHighlights([])
        setQuery(s)
    }

    const history = useHistory()

    const EditButton = ({ id }) => {
        const history = useHistory()
        const role = localStorage.getItem('role')
        const handleEditClick = async (val) => {
            if (val === EDIT_PAGES.PUBLISH) {
              
                const r = window.confirm('Are you sure you want to publish?')
               
                if (!r) {
                    return false
                }

                if (fileName.substring(fileName.indexOf('.')+1) == "xml"){
                    var builder = new xml2js.Builder()
                    var editedTranscript = builder.buildObject(transcriptData)
                }

                else {
                    var editedTranscript = parseSRT(transcriptData)
                }
               
                try {
                    const res = await axios.put(
                        `${process.env.REACT_APP_STUDIO_URL}/upload/transcript`,
                        { fileName, data: editedTranscript, isDraft : false }
                    )
                    toast.success('Transcript published successfully');
                    published = true;
                    //isDefaultTranscript = true;
                } catch (ex) {
                    toast.error(ex.message)
                }
                
                return false;
            }
            setCurrentPage(val)
            if (val === EDIT_PAGES.EDIT_VIDEO) {
                history.push(`/studio/${id}`)
            }
        }

        if (role === 'admin' || role === 'uploader') {
            return (
                <DropDown
                    selected={currentPage}
                    list={[
                        'Edit',
                        EDIT_PAGES.EDIT_VIDEO,
                        EDIT_PAGES.EDIT_TRANSCRIPT,
                        // EDIT_PAGES.PUBLISH,
                    ]}
                    setSelected={handleEditClick}
                />
            )
        } else return null
    }

    const performGlobalSearch = (s) => {
        history.push(`/search/${s}`)
    }

    const handleTranscriptHistory = (position) => {
        
        if(actions[position]){
            setTranscriptData(JSON.parse(actions[position]))
        }
    }
    
    let _key = 0
    let { tempResourceUrl: mediaUrl } = recording
    mediaUrl = mediaUrl.substring(mediaUrl.indexOf('recordings/'))
    const studioUrl = process.env.REACT_APP_STUDIO_URL
    mediaUrl = `${studioUrl}/static/${mediaUrl}`

    // const [showNEROptions, setShowNEROptions] = useState(false);

    return (
        <>
            <RecordingSearch
                query={query}
                performSearch={performSearch}
                performGlobalSearch={performGlobalSearch}
                speakers={speakers}
            />
            <FlexContainerCentered id="Recording" stretch={true}>
                <VerticalLayout id="LeftPanel">
                    <AVFile
                        jump={jump}
                        jumpTo={jumpTo}
                        setSeek={setSeek}
                        highlights={highlights}
                        currentCaption={currentCaption}
                        imageAndSoundCaptions={imageAndSoundCaptions}
                        path={mediaUrl}
                    />
                </VerticalLayout>
                <VerticalLayout
                    id="RightPanel"
                    className={cx('recordingVerticalLayout', mediaType)}
                >
                    <div style={{ display: 'flex', width: '100%' }}>
                        <Title
                            small
                            text={recording.title}
                            query={query}
                            style={{ marginLeft: 0 }}
                        />
                        <div className="ml-auto">
                            <EditButton id={id} />
                        </div>
                    </div>
                    {recording.description.length > 0 && (
                        <Para query={query} text={recording.description} />
                    )}
                    {currentPage === EDIT_PAGES.EDIT_TRANSCRIPT && state ? (
                        <div className="mt-5 w-100">
                            <TranscriptEditor
                                state={state}
                                setState={setState}
                                fileName={fileName}
                                jumpTo={jumpTo}
                                transcriptData={transcriptData}
                                transcriptXMLPath={defaultTranscriptPath}
                                setTranscriptData={setTranscriptData}
                                handleWordChange={handleWordChange}
                            />
                        </div>
                    ) : (
                        <>
                            {tags.length > 0 && (
                                <FlexWrap className="recordingTagsContainer">
                                    Tags:
                                    {tags.splice(0, 15).map((tag) => (
                                        <Tag
                                            queryWords={
                                                query ? query.split(' ') : null
                                            }
                                            onClick={() => performSearch(tag)}
                                            key={_key++}
                                            name={tag}
                                        />
                                    ))}
                                </FlexWrap>
                            )}
                            {recording.speakers.length > 0 && (
                                <FlexWrap className="recordingTagsContainer">
                                    Speakers:
                                    {recording.speakers.map((s) => (
                                        <Tag
                                            queryWords={
                                                query ? query.split(' ') : null
                                            }
                                            onClick={() =>
                                                performSearch(`speaker:${s}`)
                                            }
                                            key={_key++}
                                            name={s}
                                        />
                                    ))}
                                </FlexWrap>
                            )}
                            {topWords.length > 0 && (
                                <FlexWrap className="recordingTagsContainer">
                                    Top Words:
                                    {topWords.map((t) => (
                                        <Tag
                                            onClick={() => performSearch(t[0])}
                                            key={_key++}
                                            name={t[0]}
                                        />
                                    ))}
                                </FlexWrap>
                            )}
                            {/* -------------------- For NER -------------------- */}                       
                            {/* <button onClick={() => setShowNEROptions(!showNEROptions)}>
                                {`${showNEROptions ? 'Hide' : 'Show'} NER`}
                            </button> */}
                            {/* <div style={{ display: showNEROptions ? 'block' : 'none' }}>
                                {nerWords.name.length > 0 && (
                                    <FlexWrap className="recordingTagsContainer">
                                        Name:
                                        {nerWords.name.map((t) => (
                                            <Tag
                                                onClick={() => performSearch(t)}
                                                key={_key++}
                                                name={t}
                                            />
                                        ))}
                                    </FlexWrap>
                                )}
                                {nerWords.country.length > 0 && (
                                    <FlexWrap className="recordingTagsContainer">
                                        Country:
                                        {nerWords.country.map((t) => (
                                            <Tag
                                                onClick={() => performSearch(t)}
                                                key={_key++}
                                                name={t}
                                            />
                                        ))}
                                    </FlexWrap>
                                )}
                                {nerWords.commodity.length > 0 && (
                                    <FlexWrap className="recordingTagsContainer">
                                        Commodity:
                                        {nerWords.commodity.map((t) => (
                                            <Tag
                                                onClick={() => performSearch(t)}
                                                key={_key++}
                                                name={t}
                                            />
                                        ))}
                                    </FlexWrap>
                                )}
                            </div> */}
                            {/* -------------------- For NER -------------------- */}
                            <Transcript
                                query={query}
                                seek={seek}
                                jumpTo={jumpTo}
                                highlights={highlights}
                                setHighlight={setHighlight}
                                updateCurrentCaption={setCurrentCaption}
                                updateImageAndSoundCaptions={
                                    setImageAndSoundCaptions
                                }
                                defaultTranscript={recording._defaultTranscript}
                                defaultImageCaption={
                                    recording._defaultImageCaption
                                }
                                defaultSoundCaption={
                                    recording._defaultSoundCaption
                                }
                                transcriptId={transcriptId}
                                transcripts={recording._transcripts}
                                imageCaptions={recording._imageCaptions}
                                soundCaptions={recording._soundCaptions}
                                recordingId={id}
                                setSpeakers={setSpeakers}
                                setTopWords={setTopWords}
                            />
                        </>
                    )}
                </VerticalLayout>
            </FlexContainerCentered>
            {/* <div className="p-2">
                {currentPage === EDIT_PAGES.EDIT_TRANSCRIPT &&
                    transcriptData && (
                        <Timeline
                            mediaUrl={mediaUrl}
                            jump={jump}
                            jumpTo={jumpTo}
                            setSeek={setSeek}
                            seek={seek}
                            duration={recording.duration}
                            segments={transcriptData.AudioDoc.SegmentList}
                            handleTranscriptHistory={handleTranscriptHistory}
                            changesTrack={actions.length}
                        />
                    )}
            </div> */}
        </>
    )
}

const RecordingSearch = (props) => {
    const getFuzzyProps = (speakers = []) => [
        ...speakers.map((s) => `speaker:${s}`),
        ...Object.keys(emotions).map((k) => `emotion:${k.toLowerCase()}`),
    ]
    const [newQuery, setNewQuery] = useState(props.query || '')
    const [searchIn, setSearchIn] = useState(THIS_REC)
    const [searcher, setSearcher] = useState(
        new FuzzySearch(getFuzzyProps(props.speakers))
    )
    const [matches, setMatches] = useState([])
    const history = useHistory()
    const performSearch = (query) => {
        if (searchIn === THIS_REC) props.performSearch(query || newQuery)
        else props.performGlobalSearch(query || newQuery)
    }
    const handleChange = (newQuery = '') => {
        if (searchIn === THIS_REC && newQuery !== '') {
            setMatches(searcher.search(newQuery))
        } else {
            setMatches([])
        }
        setNewQuery(newQuery)
    }
    useEffect(() => {
        setNewQuery(props.query)
    }, [props.query])
    useEffect(() => {
        setSearcher(new FuzzySearch(getFuzzyProps(props.speakers)))
    }, [props.speakers])
    return (
        <div className="recordingNavBar">
            <Title small text="Magor" onClick={(_) => history.push('/')} />
            <div style={{ display: 'flex', position: 'relative' }}>
                <SearchBar
                    small
                    value={newQuery}
                    placeholder="Search"
                    performSearch={performSearch}
                    handleChange={handleChange}
                    matches={matches}
                />
                <div id="DropDownContainer">
                    <DropDown
                        selected={searchIn}
                        list={[THIS_REC, ALL_REC]}
                        setSelected={setSearchIn}
                    />
                </div>
                <SearchButton
                    small
                    style={{ borderLeft: 'none' }}
                    performSearch={() => performSearch()}
                />
            </div>
            <UserDropdown />
        </div>
    )
}

const RecordingRenderer = (props) => {
    const { id, query, transcriptId } = useParams()
    if (id == null) return null
    return (
        <Suspense
            SuccessDisplay={Recording}
            successProps={{ query, id, transcriptId }}
            method="getOne"
            _key={id}
            params={['recordings', { id, transcriptId }]}
        />
    )
}

export default RecordingRenderer;

export function myFunction(){return isDefaultTranscript};
export function publishClick(){return published};